import React from 'react';
import PropTypes from 'prop-types';
import Download from '../../Previewer/components/Header/Download';
import { downloadLink } from '../../Utils';
import * as Translations from '../../Previewer/providers/i18n';

import './style.scss';

export const FileStatusMessage = ({ icon, title, subtitle, footerContent, downloadUrl, type, i18n }) => (
    <div className="file-status-message-base">
        <span className="icn-file">
            {typeof icon === 'string' ? <i className={icon}/> : icon}
        </span>
        <span className="title-content">
            {title}
        </span>
        <span className="subtitle-content">
            {subtitle}
        </span>
        <div className="footer-content">
            {footerContent}
        </div>
        <div className="btn-download-container">
            {downloadUrl && <Download text={i18n.t('attachments_preview.header.download')} onClick={() => downloadLink(downloadUrl, 'Viewer', type)} className="btn-lrg-standard btn-download"/>}
        </div>
    </div>
);

FileStatusMessage.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    downloadUrl: PropTypes.string,
    footerContent: PropTypes.string,
    type: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(FileStatusMessage);
